// extracted by mini-css-extract-plugin
export default {"title":"Header_title__HRXPx","selectBlock":"Header_selectBlock__A0Zeh","buttonCountry":"Header_buttonCountry__SvAf7"};